/**
 * @file trash.js
 * @location src/store/reducers/taskActions/crud/trash.js
 * @role 업무 soft delete · 자동 정리 액션
 *
 *  DELETE_TASK              tasks → deletedTasks 이동 (deletedAt 부착)
 *  RESTORE_TASK             deletedTasks → tasks 복귀 (deletedAt 제거)
 *  PURGE_TASK               영구 삭제
 *  AUTO_PURGE_TRASH         30일 경과 자동 정리
 */

export const trashActions = {
  DELETE_TASK: (state, action) => {
    const task = state.tasks.find(t => t.id === action.id);
    if (!task) return state;
    return {
      ...state,
      tasks: state.tasks.filter(t => t.id !== action.id),
      deletedTasks: [
        ...(state.deletedTasks ?? []),
        { ...task, deletedAt: new Date().toISOString() },
      ],
    };
  },

  RESTORE_TASK: (state, action) => {
    // 두 진입점 호환: { id } (휴지통/Undo 단순화) 또는 { task } (구버전 snapshot)
    const id = action.id ?? action.task?.id;
    if (!id) return state;
    if (state.tasks.some(t => t.id === id)) return state; // 중복 방지
    const trashed = (state.deletedTasks ?? []).find(t => t.id === id) ?? action.task;
    if (!trashed) return state;
    const { deletedAt: _del, ...rest } = trashed;
    return {
      ...state,
      tasks: [...state.tasks, rest],
      deletedTasks: (state.deletedTasks ?? []).filter(t => t.id !== id),
    };
  },

  PURGE_TASK: (state, action) => ({
    ...state,
    deletedTasks: (state.deletedTasks ?? []).filter(t => t.id !== action.id),
  }),

  AUTO_PURGE_TRASH: (state) => {
    const cutoff = Date.now() - 30 * 24 * 3600 * 1000;
    const kept = (state.deletedTasks ?? []).filter(t => {
      const at = t.deletedAt ? Date.parse(t.deletedAt) : NaN;
      return Number.isFinite(at) ? at >= cutoff : true; // 파싱 실패 시 보존
    });
    if (kept.length === (state.deletedTasks ?? []).length) return state;
    return { ...state, deletedTasks: kept };
  },
};
